import React, { Component } from 'react'
import { connect } from 'react-redux'
import { injectIntl } from 'react-intl'
import SelectList from 'components/common/SelectList'
import { fetchSpeciesList, setActiveSpecies } from 'reducers/seaLice/reducer'
import messages from 'components/Apps/SeaLiceMonitor/translate'

class SpeciesFilter extends Component {
  componentDidMount() {
    this.props.fetchSpeciesList()
  }

  onSpeciesChange = v => {
    if (v) {
      this.props.setActiveSpecies(v.index)
    }
  }

  render() {
    const {
      speciesList,
      activeSpecies,
      intl: { formatMessage },
    } = this.props

    return (
      <div className="caption-panel">
        <SelectList
          setFirstValue
          label={formatMessage(messages.species)}
          className="sealice-table-select"
          name="species"
          onChange={this.onSpeciesChange}
          list={speciesList}
          value={activeSpecies}
          map={{
            index: 'id',
            text: 'name',
          }}
        />
      </div>
    )
  }
}

export default connect(
  state => ({
    speciesList: state.getIn(['seaLice', 'speciesList']),
    activeSpecies: state.getIn(['seaLice', 'activeSpecies']),
  }),
  {
    fetchSpeciesList,
    setActiveSpecies,
  },
)(injectIntl(SpeciesFilter))
